import { Input } from "antd";
import axios from "axios";
import React, { useCallback, useEffect } from "react";
import { debounceAsync } from "../../../../helper/helpers";
import { DEBOUNCE_TIME } from "../../../../constants/constants";

const SearchBox = React.forwardRef((props, ref) => {
  const {
    className,
    data,
    disabled,
    dropdownVisible,
    infiniteScroll,
    loadMoreData,
    placeholder,
    setState,
    value,
  } = props;
  const { inputRef, listRef, reachedBottom } = ref.current;

  useEffect(
    () => {
      if (dropdownVisible) inputRef.current && inputRef.current.focus();
      else {
        setState((st) => ({
          ...st,
          searchQuery: "",
        }));
      }
    },
    [dropdownVisible]
  );

  useEffect(
    () => {
      if (infiniteScroll && value === "") {
        setState((st) => ({ ...st, loading: true }));
        loadMoreData(1)
          .then((count) => {
            setState((st) => ({
              ...st,
              loading: false,
              pageNumber: 2,
              count,
              error: false,
            }));
          })
          .catch((error) => {
            const requestCancelled = !axios.isCancel(error);
            setState((st) => ({
              ...st,
              loading: !requestCancelled ? true : false,
              error: requestCancelled,
            }));
          });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [value]
  );

  const loadMoreDataDebounced = useCallback(
    debounceAsync(loadMoreData, DEBOUNCE_TIME, false),
    [loadMoreData]
  );

  const handleSearch = (e) => {
    const searchText = e.target.value;
    setState((st) => ({
      ...st,
      pageNumber: 2,
      searchQuery: searchText,
      loading: infiniteScroll ? true : false,
    }));

    if (infiniteScroll) {
      loadMoreDataDebounced(1, searchText, false)
        .then((count) => {
          setState((st) => ({
            ...st,
            loading: false,
            dropdownVisible: true,
            count,
            error: false,
          }));
        })
        .catch((error) => {
          const requestCancelled = !axios.isCancel(error);
          setState((st) => ({
            ...st,
            loading: !requestCancelled ? true : false,
            error: requestCancelled,
          }));
        })
        .finally(() => {
          listRef.current && listRef.current.resetAfterIndex(0);
          listRef.current && listRef.current.scrollTo(data.length - 1);
        });

      reachedBottom.current = false;
    }
  };

  return (
    <Input
      disabled={disabled}
      placeholder={placeholder}
      ref={inputRef}
      value={value}
      className={`multi-select-input ${className}`}
      onChange={handleSearch}
    />
  );
});

export default SearchBox;
